module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "learn-box"
  }, [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "is-link": "",
      "title": "设置"
    },
    nativeOn: {
      "click": function($event) {
        _vm.headerRightBtnClick()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "choose-remote"
  }, [_c('h4', [_vm._v("添加遥控器")]), _vm._v(" "), _c('ul', {
    staticClass: "choose-remote-ul"
  }, _vm._l((_vm.deviceList), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.panelClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../../assets/img/device/icon_' + item.name + '.png')
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-align-center font-size-m"
    }, [_vm._v(_vm._s(item.chName.split('遥控器')[0]))])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2231d981"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/device/xiaofang/Index.vue
// module id = 878
// module chunks = 1